import React from "react";
import { Box, Typography } from "@mui/material";
import GradeSlider from "./GradeSlider";

export default function SkillRow({
  displayName,
  levelValue,
  onChangeLevel,
  isChild = false,
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "minmax(140px, 0.28fr) minmax(240px, 0.72fr)" },
        alignItems: "center",
        columnGap: 6,
        rowGap: 1,
        p: { xs: 0, sm: 2 }
        ,
        ml: 0,
      }}
    >
      {/* 左側（スキル名＋年数） */}
      <Box
        sx={{
          textAlign: "left",
          
          pl: { xs : 0, sm: isChild ? 5 : 0 },
        }}
      >
        <Typography sx={{ fontWeight: 700 }}>{displayName}</Typography>
      </Box>
      {/* 右側（スライダー） */}
      <GradeSlider levelValue={levelValue} onChangeLevel={onChangeLevel} />
    </Box>
  );
}